import { createRouter, createWebHistory } from 'vue-router'
import showLoginOrRegPopup from '@a/components/showLoginOrRegPopup'
import { useUserInfo } from '@/store'
// import i18n from '@/i18n'
import GooglePage from '@/views/__template/index.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',  redirect: '/home'
    },
    {
      path: '/template',
      name: 'template',
      component: GooglePage
    }
  ]
})

// const { t } = i18n.global
export let previousRoute: any = ref(null)

router.beforeEach((to, from, next) => {
  if (to.path != '/home') {
    setTimeout(() => {
      document.documentElement.scrollTop = 0
    }, 100)
  }

  previousRoute.value = from

  if (useUserInfo().isLoggedin) {
    if (to.path === '/login' || to.path === '/reg') {
      // showToast({
      //   message: t('Common.AlreadyLogin'),
      //   icon: 'warning',
      //   iconSize: 20,
      //   duration: 3000
      // })
      next({ path: '/home', replace: true })
    } else next()
  } else {
    const needCheckLogin = to.meta.needLogin
    if (needCheckLogin) {
      if (from.path === to.path || to.path == '/meu') {
        next({ path: '/login' })
      } else {
        // console.log('to', to.query, 'from', from.query, router.currentRoute.value.query)
        if (from.query.pwaredirect) {
          next()
          return
        }

        showLoginOrRegPopup()
      }
    } else next()
  }
})

export default router
